import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtracts } from '../AppActionTypes';

export interface CreateExtractsAction extends Action {
  selectedContent: IContentInfo[];
}

export function createExtractsMethod(
  selectedContent: IContentInfo[]
): CreateExtractsAction {
  return {
    type: CreateExtracts,
    selectedContent
  };
}
